 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"a46c3f1b","chunk-09155df3":"5143fc3c","chunk-09162720":"f83a94a8","chunk-097e0872":"d1c547c9","chunk-0e93a01c":"e490905c","chunk-136ad640":"8e9b5ebd","chunk-1697f4fb":"1731df87","chunk-1aa77ef5":"87c6fdb4","chunk-1af6de4c":"e65c5e1a","chunk-1bc223c0":"d05728d8","chunk-1bff95de":"c5ef07fb","chunk-1c4705f4":"bded6dc1","chunk-1c875eac":"f1467ed9","chunk-1c99de0c":"bb91eb71","chunk-1dbc15a2":"02b3b51b","chunk-2006abd3":"ccf558ba","chunk-21a638c2":"ed546284","chunk-21a76241":"175404e8","chunk-25d83ca8":"13478065","chunk-279decab":"c4b05979","chunk-2d0a463b":"ea498bb9","chunk-2d0ac931":"cc71baa3","chunk-2d0af85b":"7fff7bfa","chunk-198d6947":"237b7fc7","chunk-4426b7d0":"a0dc4640","chunk-52b8318c":"293dc472","chunk-593780c4":"c06d5964","chunk-efd37f02":"1edfc458","chunk-2d0c073f":"8bbfc415","chunk-2d0c211b":"56bba833","chunk-2d0cf315":"c8f5219d","chunk-2d0d43da":"b5b3fe26","chunk-2d0da04a":"bab99e71","chunk-2d0e5812":"b85a24a4","chunk-2d213189":"7129d9d4","chunk-2d217def":"9b86ebe8","chunk-2d217e6a":"3d0c08cc","chunk-2d218068":"3f74f8bc","chunk-2d21a9aa":"bdd6764c","chunk-2d21da73":"0425139d","chunk-2d222cca":"4226e9f6","chunk-2d22895d":"4ebcf334","chunk-2d2304d2":"791aa685","chunk-2d23721e":"7970ea5d","chunk-2d237b00":"ee3ae924","chunk-30dd9750":"9d0a16d9","chunk-37f2300e":"c1872a7e","chunk-3b2e36e1":"1feee792","chunk-3dd7b8e2":"670776b2","chunk-3ed29de3":"8bc96b50","chunk-41c0f7a4":"4ac74631","chunk-426f2f16":"bcfdb743","chunk-462c869e":"3831a660","chunk-47245a33":"b781d95e","chunk-4739acd0":"df3e456c","chunk-50d1470f":"32df4376","chunk-53b1137a":"07a4269a","chunk-541ea42d":"5ca556af","chunk-54bbd082":"e1139ad1","chunk-59d4c87c":"835ad40d","chunk-5a8ac886":"06a47954","chunk-5db1d9a6":"748efa37","chunk-5db98da0":"f3525cb2","chunk-5f2d338e":"320723f5","chunk-5ff96a24":"28e3d4db","chunk-60d521ba":"4ef26a6b","chunk-63a96d9e":"b3380c24","chunk-69eb8776":"b491e34d","chunk-6d375f34":"6ab5e17c","chunk-6de370b1":"4321b2d1","chunk-73de1d02":"a220742c","chunk-7548ca2d":"a2551552","chunk-79f1dac7":"6578151d","chunk-7dac73af":"4a751838","chunk-8bb7f81e":"aa9d06d5","chunk-8e5af1a8":"7ef64891","chunk-02926f6d":"db4031a8","chunk-0310b232":"d53f5086","chunk-06aa79bc":"84a47b1c","chunk-550f3b71":"7c6fd8f8","chunk-58fb877f":"1af5589f","chunk-b921ad26":"c0cd32a9","chunk-1fd3a5e2":"6f0f2c22","chunk-2f780aac":"c28b0c3f","chunk-a9395c36":"4fa44d91","chunk-d0e8aa0a":"82bc4ccb","chunk-d4e11a7a":"33d2f5af","chunk-d8413eac":"418b6e6e","chunk-e45963c0":"b0d1207a","chunk-e5275ddc":"f1106771","chunk-eaa2b130":"9b7d14d0","chunk-f52e30da":"d6c6b46d","chunk-f97f643c":"daccdafb","polyfills-core-js":"d8d93617","polyfills-dom":"d8a6324a","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76","chunk-2d2297f7":"e095e0ad","chunk-1c5381f6":"7ff4f586","chunk-2d0c9758":"74d2ad66","chunk-2d0b33e3":"f159d0f5","chunk-2d0b9074":"33a35541","chunk-2d0b9280":"f03cd0ee","chunk-2d0baac9":"378f0865","chunk-2d2376e6":"8db0e7a4","chunk-4ed8c73e":"15eb47b6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-136ad640":1,"chunk-1697f4fb":1,"chunk-1aa77ef5":1,"chunk-1af6de4c":1,"chunk-1c875eac":1,"chunk-1c99de0c":1,"chunk-2006abd3":1,"chunk-21a638c2":1,"chunk-279decab":1,"chunk-198d6947":1,"chunk-4426b7d0":1,"chunk-52b8318c":1,"chunk-593780c4":1,"chunk-efd37f02":1,"chunk-3b2e36e1":1,"chunk-3dd7b8e2":1,"chunk-50d1470f":1,"chunk-5db1d9a6":1,"chunk-5db98da0":1,"chunk-5f2d338e":1,"chunk-60d521ba":1,"chunk-63a96d9e":1,"chunk-6de370b1":1,"chunk-73de1d02":1,"chunk-7dac73af":1,"chunk-02926f6d":1,"chunk-0310b232":1,"chunk-06aa79bc":1,"chunk-550f3b71":1,"chunk-58fb877f":1,"chunk-b921ad26":1,"chunk-1fd3a5e2":1,"chunk-2f780aac":1,"chunk-d4e11a7a":1,"chunk-e45963c0":1,"chunk-f52e30da":1,"chunk-f97f643c":1,"chunk-1c5381f6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-136ad640":"1001c10f","chunk-1697f4fb":"16329dca","chunk-1aa77ef5":"18e47a69","chunk-1af6de4c":"92b27aba","chunk-1bc223c0":"31d6cfe0","chunk-1bff95de":"31d6cfe0","chunk-1c4705f4":"31d6cfe0","chunk-1c875eac":"3e7365da","chunk-1c99de0c":"971e079c","chunk-1dbc15a2":"31d6cfe0","chunk-2006abd3":"eab0ce59","chunk-21a638c2":"b866c604","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-279decab":"026f3cb0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0af85b":"31d6cfe0","chunk-198d6947":"b9a465a0","chunk-4426b7d0":"11004a92","chunk-52b8318c":"808fea28","chunk-593780c4":"335adade","chunk-efd37f02":"b4c859c8","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d2304d2":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-37f2300e":"31d6cfe0","chunk-3b2e36e1":"e99e674b","chunk-3dd7b8e2":"1ab68361","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-426f2f16":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-50d1470f":"832badce","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5db1d9a6":"d27c403c","chunk-5db98da0":"bacd0032","chunk-5f2d338e":"61e5a25d","chunk-5ff96a24":"31d6cfe0","chunk-60d521ba":"12319d8f","chunk-63a96d9e":"9bc51aeb","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-6de370b1":"f012c034","chunk-73de1d02":"fa652a4a","chunk-7548ca2d":"31d6cfe0","chunk-79f1dac7":"31d6cfe0","chunk-7dac73af":"bccdd6f9","chunk-8bb7f81e":"31d6cfe0","chunk-8e5af1a8":"31d6cfe0","chunk-02926f6d":"642c0076","chunk-0310b232":"9eb8983c","chunk-06aa79bc":"e4f5e237","chunk-550f3b71":"bd5015a2","chunk-58fb877f":"d5a3cbac","chunk-b921ad26":"8389ad74","chunk-1fd3a5e2":"a00c4819","chunk-2f780aac":"f5402f9c","chunk-a9395c36":"31d6cfe0","chunk-d0e8aa0a":"31d6cfe0","chunk-d4e11a7a":"4d9baf1e","chunk-d8413eac":"31d6cfe0","chunk-e45963c0":"4830a3a7","chunk-e5275ddc":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","chunk-f52e30da":"7c8cfa0c","chunk-f97f643c":"c81d3fd1","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d2297f7":"31d6cfe0","chunk-1c5381f6":"42803d47","chunk-2d0c9758":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9074":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d2376e6":"31d6cfe0","chunk-4ed8c73e":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
